import React, { Component } from 'react';
import WidgetPropTypes from '../types';
import WidgetPagePropTypes from '../../WidgetPage/types';
import css from './ReferralCode.module.scss';
import Input from '../../../components/UI/CustomInputField';
import { PROMO_CODE_STATE } from '../../App/constants';
import Checkbox from '../../../components/UI/Checkbox/index.tsx';
import { storageAvailable } from '../../../helpers';

export const WIDGET_NAME = 'set_referral_code';
const MIN_REFERRAL_INPUT_LENGTH = 3;
const MAX_REFERRAL_INPUT_LENGTH = 20;

class ReferralCode extends Component {
  constructor() {
    super();

    this.state = {
      referralCode: '',
      displayInput: false,
      error: false,
      validatedCode: false,
      validationMessage: '',
      typing: false,
      typingTimeout: 0,
      smsNotificationsChecked: false,
      referralRewardValue: false,
      utmSource: ''
    };
  }

  componentDidMount() {
    if (storageAvailable('localStorage')) {
      this.setState({
        referralRewardValue: localStorage.getItem('referralRewardValue'),
        utmSource: JSON.parse(localStorage.getItem('adsSuperProperties'))
          ?.utm_source
      });
    }

    this.props.segment.page('Referral Code', 'Registration');
    if (
      this.props.toggles.smsNotificationsEnabled &&
      this.props.toggles.smsNotificationsDefaultChecked
    ) {
      this.toggleSmsNotificationsChecked();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.toggles.promoCodeVerificationEnabled) {
      if (prevProps.user.promoCode !== this.props.user.promoCode) {
        this.validatePromoCode(this.props.user.promoCode);
      }
    }
  }

  getOfferApplied = () => {
    if (storageAvailable('localStorage')) {
      const maxRedemptionLimit = localStorage.getItem('maxRedemptionLimit');
      const { referralRewardValue } = this.state;
      const value = !Number.isNaN(referralRewardValue)
        ? referralRewardValue
        : 0;

      if (maxRedemptionLimit !== 'true' && value > 0) {
        return (
          <p
            className={css.textOffedApplied}
          >{`$${referralRewardValue} offer applied`}</p>
        );
      }
      return <p className={css.textOffedApplied}>{`$0 offer applied`}</p>;
    }
  };

  errorChecking = async () => {
    if (
      this.state.referralCode &&
      (this.state.referralCode.length < MIN_REFERRAL_INPUT_LENGTH ||
        this.state.referralCode.length > MAX_REFERRAL_INPUT_LENGTH)
    ) {
      this.setState({
        error: true
      });
      this.props.createError({
        message: `The referral code '${this.state.referralCode}' is invalid. Please try another code or delete.`,
        registrationStep: WIDGET_NAME
      });
      throw new Error();
    }
    if (this.props.toggles.smsNotificationsEnabled) {
      this.props.setSmsNotificationsOptedStatus({
        optedStatus: this.state.smsNotificationsChecked
          ? 'opted_in'
          : 'opted_out'
      });
    }
    return false;
  };

  toggleInput = () => {
    this.setState({
      displayInput: !this.state.displayInput
    });
  };

  validatePromoCode = value => {
    const failedState = {
      error: true,
      validatedCode: false,
      validationMessage: ''
    };
    const successState = {
      error: false,
      validatedCode: true,
      validationMessage: 'Promotion applied!'
    };
    const stateMap = new Map();
    stateMap.set(() => !this.state.referralCode, {
      ...failedState,
      error: false
    });
    stateMap.set(
      () =>
        value?.message?.includes('Shareable not found') ||
        value?.http_status_code === 403,
      {
        ...failedState,
        validationMessage:
          'Oops, we don’t have a promotion tied to that code, please try another.'
      }
    );
    stateMap.set(() => value?.state === PROMO_CODE_STATE.redeemed, {
      ...failedState,
      validationMessage:
        'Oops, that promotion code has already been redeemed, please try another.'
    });
    stateMap.set(() => value?.partner_reward_supplier_id, {
      ...successState,
      validationMessage: value.partner_reward_supplier_id
        ? `${value.partner_reward_supplier_id} applied!`
        : 'Promotion applied!'
    });
    stateMap.set(() => value?.personId, {
      ...successState,
      validationMessage: value?.content?.title
        ? `${value.content.title} applied!`
        : 'Promotion applied!'
    });

    const key = Array.from(stateMap.keys()).find(condition => condition());
    const validationState = stateMap.has(key)
      ? stateMap.get(key)
      : {
          error: true,
          validatedCode: false,
          validationMessage:
            'We’re unable to verify your promo code at the moment. You can continue signing up and we’ll apply the promotion afterwards.'
        };

    this.setState(validationState);
  };

  onPromoCodeSearch = value => {
    if (
      value.length >= MIN_REFERRAL_INPUT_LENGTH &&
      value.length <= MAX_REFERRAL_INPUT_LENGTH
    ) {
      if (this.state.typingTimeout) {
        clearTimeout(this.state.typingTimeout);
      }

      this.setState({
        referralCode: value,
        typing: false,
        typingTimeout: setTimeout(() => {
          this.props.verifyPromoCode(value, this.props.app.registrationToken);
        }, 800)
      });
    } else if (value.length === 0) {
      this.setState({
        error: false,
        referralCode: value,
        validatedCode: false,
        validationMessage: ''
      });
    }
  };

  toggleSmsNotificationsChecked = () => {
    this.setState({
      smsNotificationsChecked: !this.state.smsNotificationsChecked
    });
  };

  render() {
    const { changeAnswerValue, widget, app } = this.props;

    return (
      <div>
        {this.props.toggles.smsNotificationsEnabled && (
          <div className={css.smsNotificationsContainer}>
            <Checkbox
              id="sms-notifications-checkbox"
              checked={this.state.smsNotificationsChecked}
              onClick={this.toggleSmsNotificationsChecked}
              data-e2e="sms-notifications-checkbox"
              label="Allow text notifications for marketing updates and promos*"
            />
          </div>
        )}
        {app.linkSource !== 'prepaid' && (
          <>
            <div className={css.referralCodeContainer}>
              {this.state.utmSource === 'extole' &&
              !!this.state.referralRewardValue ? (
                <div className={css.offerApplied}>
                  <img
                    src="../../../static/green-check-circle.svg"
                    alt="check-mark"
                  />
                  {this.getOfferApplied()}
                </div>
              ) : (
                <>
                  <div
                    className={css.referralCodeHeader}
                    onClick={this.toggleInput}
                    data-e2e="referral-code-open-button"
                  >
                    <img
                      className={this.state.displayInput ? css.open : ''}
                      src={'../../static/plus-sign.svg'}
                    />
                    <p className={css.referralCodeText}>Add a Promo Code</p>
                  </div>
                  <div
                    className={this.state.displayInput ? '' : css.hiddenInput}
                  >
                    <Input
                      id="referralCodeId"
                      placeholder="Your promo code"
                      type="text"
                      value={this.state.referralCode}
                      onChange={value => {
                        this.setState({
                          referralCode: value
                        });
                        changeAnswerValue(widget, value);
                        if (this.props.toggles.promoCodeVerificationEnabled)
                          this.onPromoCodeSearch(value);
                      }}
                      data-e2e="referral-code-input"
                      error={this.state.error}
                      maxLength={MAX_REFERRAL_INPUT_LENGTH}
                      hideLabel={true}
                      smallerMarginBottom={true}
                      className={css.invalidCode}
                    />
                  </div>
                </>
              )}
            </div>
            <div
              className={
                this.state.displayInput ? css.codeValidation : css.hiddenInput
              }
            >
              <img
                className={
                  this.state.validationMessage
                    ? css.validationIcon
                    : css.hiddenInput
                }
                src={
                  this.state.error
                    ? '/static/error-icon2.svg'
                    : '/static/valid-icon.svg'
                }
                alt="Status Icon"
              />
              <span
                data-testid="validation-message"
                className={`${css.validationMessage} ${
                  this.state.validatedCode ? css.validCode : css.invalidCode
                }`}
              >
                {this.state.validationMessage}
              </span>
            </div>
          </>
        )}
      </div>
    );
  }
}

ReferralCode.propTypes = {
  changeAnswerValue: WidgetPropTypes.changeAnswerValue.isRequired,
  index: WidgetPropTypes.index.isRequired,
  onClick: WidgetPropTypes.onClick.isRequired,
  shouldEnable: WidgetPropTypes.shouldEnable.isRequired,
  widget: WidgetPropTypes.widget.isRequired,
  app: WidgetPagePropTypes.app
};

export default ReferralCode;
